import { AllContentNodes, ContentNode } from '../lib/types/content.types';
import { graphql, useStaticQuery } from 'gatsby';

export const useAllContent = (): {
  posts: ContentNode[];
  howtos: ContentNode[];
  snippets: ContentNode[];
  fridays: ContentNode[];
} => {
  const {
    allMdx: { nodes: posts },
    howtos: { nodes: howtos },
    snippets: { nodes: snippets },
    fridays: { nodes: fridays },
  }: AllContentNodes = useStaticQuery(graphql`
    query SiteContent {
      allMdx(filter: { frontmatter: { type: { eq: "post" } } }) {
        nodes {
          id
          frontmatter {
            title
            permalink
          }
          excerpt(pruneLength: 10000)
        }
      }
      howtos: allMdx(filter: { frontmatter: { type: { eq: "howto" } } }) {
        nodes {
          id
          frontmatter {
            title
            permalink
          }
          excerpt(pruneLength: 10000)
        }
      }
      snippets: allMdx(filter: { frontmatter: { type: { eq: "snippets" } } }) {
        nodes {
          id
          frontmatter {
            title
            permalink
          }
          excerpt(pruneLength: 10000)
        }
      }
      fridays: allMdx(filter: { frontmatter: { type: { eq: "friday" } } }) {
        nodes {
          id
          frontmatter {
            title
            permalink
          }
          excerpt(pruneLength: 10000)
        }
      }
    }
  `);

  return { posts, howtos, snippets, fridays };
};
